import { z } from 'zod';

export const ChartDataSchema = z.object({
  column: z.string(),
  data: z.array(z.tuple([z.number(), z.number()])),
});

export type ChartData = z.infer<typeof ChartDataSchema>;
